export default __webpack_public_path__ + "static/media/GCC_Playbook1.e083750b.jpg";